import { Link } from 'react-router-dom';
import '../styles/service.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Aichanger() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="aichanger-process">
        <div className="m-auto content-padding aic-process-container">
          <div className="aic-process-title">
            <div>
              <h2 className="color-primary">TAKE 웹 전환 서비스</h2>
              <p className="fs-md mt-20">
                기존 Client/Sever 및 ActiveX 기반 시스템을
                <br />
                HTML5 기반의 웹 표준 시스템으로 전환해주는 자동화 서비스
              </p>
            </div>
            <div>
              <Link to="/contact?service=aichanger&no=01" className="fw-bold fs-base">
                서비스 도입 문의
              </Link>
            </div>
          </div>
          <div className="aic-process-image">
            <img src="./images/img-aichanger-process.svg" alt="aichanger-process" />
          </div>
          <div className="aic-process-image-mo">
            <img src="./images/img-aichanger-process-mo.svg" alt="aichanger-process" />
          </div>
          <h3 className="content-title02 mt-100">
            <strong>AIChanger</strong> Process Orchestration
          </h3>
          <div className="aic-process-image">
            <img src="./images/img-aichanger-process02.svg" alt="aichanger-process02" />
          </div>
          <div className="aic-process-image-mo">
            <img src="./images/img-aichanger-process02-mo.svg" alt="aichanger-process02" />
          </div>
        </div>
      </section>
      <section id="aichanger-banner" className="aic-banner">
        <div className="m-auto banner-container">
          <div className="mb-32">
            <img src="./images/logo-aichanger.svg" alt="aichangerlogoimage" />
          </div>
          <p className="fs-md fw-bold mb-60">
            RPA와 AI 학습 기반의 자동화 기술을 활용하여
            <br className="pc-none" /> 기존 C/S 시스템을&nbsp;
            <br className="mo-none" />웹 표준 기반 시스템으로 자동 변환하는 inteligent 웹 전환
            서비스
          </p>
          <ul className="aic-button">
            <li>
              <Link to="/contact?service=aichanger&no=02" className="btn-outline fw-bold">
                소개자료 문의
              </Link>
            </li>
            <li>
              <Link to="/contact?service=aichanger&no=01" className="btn-filled fw-bold">
                서비스 도입 문의
              </Link>
            </li>
          </ul>
        </div>
      </section>
      <section id="aichanger-intro">
        <div className="m-auto content-padding">
          <h3 className="content-title">
            <strong>AIChanger</strong> 를 사용해야 하는 이유
          </h3>
          <div className="reason-container content-gap">
            <div className="reason-content">
              <div className="reason">
                <img src="./images/ico-aic-reason.svg" alt="reason-mark" />
                <span className="fs-base">RPA 및 AI 기술을 통한 최신 IT 트렌드 반영</span>
              </div>
              <div className="reason">
                <img src="./images/ico-aic-reason.svg" alt="reason-mark" />
                <span className="fs-base">자동화 기반의 인건비 절감 및 개발 비용 최소화</span>
              </div>
            </div>
            <div className="reason-content">
              <div className="reason">
                <img src="./images/ico-aic-reason.svg" alt="reason-mark" />
                <span className="fs-base">As-Is 시스템 분석 자동화로 개발 기간 단축</span>
              </div>
              <div className="reason">
                <img src="./images/ico-aic-reason.svg" alt="reason-mark" />
                <span className="fs-base">
                  안정적인 AI 기반 자동 변환으로 품질 및 효율성 극대화
                </span>
              </div>
            </div>
          </div>
          <h3 className="content-title02">
            <strong>AIChanger</strong> 만의 특장점
          </h3>
          <p className="fs-md content-subtitle text-center">
            AI와 RPA를 결합시킨 지능형 자동화 개발 프로세스로
            <br className="pc-none" /> IT 미래 산업을 선도할 AIChanger
          </p>
          <div className="content-bg aic-strength-container">
            <div className="aic-process-image">
              <img src="./images/img-aichanger-strength.svg" alt="aichanger-strength-image" />
            </div>
            <div className="aic-process-image-mo">
              <img src="./images/img-aichanger-strength-mo.svg" alt="aichanger-strength-image" />
            </div>
          </div>
        </div>
      </section>
      <section id="aic-effect">
        <div className="m-auto">
          <h3 className="content-title">
            <strong>AIChanger</strong> 도입 기대효과
          </h3>
          <div className="aic-effect-container">
            <div className="aic-effect-box content-box aic-boxbar-x">
              <img src="./images/ico-aic-effect01.svg" alt="aichanger 기대효과 아이콘01" />
              <p className="color-primary fs-md fw-bold">효율성</p>
              <ul>
                <li className="fs-base">대량의 데이터 분석으로 시간 단축</li>
                <li className="fs-base">개발 공정과정 최적화</li>
                <li className="fs-base">신속한 의사 결정 지원</li>
                <li className="fs-base">자동화 시스템으로 데이터 오류 최소화</li>
              </ul>
            </div>
            <div className="aic-effect-box content-box aic-boxbar-x">
              <img src="./images/ico-aic-effect02.svg" alt="aichanger 기대효과 아이콘02" />
              <p className="color-primary fs-md fw-bold">경제성</p>
              <ul>
                <li className="fs-base">효율적인 인건비 감소</li>
                <li className="fs-base">기업의 운영 예산 전략에 기여</li>
                <li className="fs-base">최신 알고리즘 반영으로 서비스 품질 개선</li>
                <li className="fs-base">To-Be 시스템 기대반영 극대화</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="aic-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img src="./images/logo-aichanger-white.svg" alt="uxboard-logo" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=aichanger&no=01" className="color-primary fw-bold">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Aichanger;
